import { FC, useMemo } from "react";
import { ItemProps } from ".";

interface CheckboxProps extends ItemProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}

const Checkbox: FC<CheckboxProps> = ({ checked, onChange, col, label, required, error, itemClassName }) => {
    const className = useMemo(() => {
        if (col) {
            return `mb-2 ${itemClassName} md:col-span-${col}`;
        }
        return `mb-2 ${itemClassName}`;
    }, [col, itemClassName]);

    return (
        <div className={className}>
            <label className="inline-block space-x-2 cursor-pointer">
                <input
                    type="checkbox"
                    checked={checked || false}
                    onChange={e => onChange?.(e.target.checked)}
                    className={`w-4 h-4 border rounded cursor-pointer ${error ? "border-red-500" : "border-gray-300"
                        }`}
                />
                <span className="text-gray-700">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </span>
            </label>
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
    );
};

export default Checkbox;